import React, {
    useContext,
    useEffect,
    useState
} from "react";
import PropTypes from "prop-types";
import axios from "axios";
import {
    Link
} from "react-router-dom";
import {
    Alert,
    Form,
    Table
} from "react-bootstrap";

import ShopsContext from "../../../context/ShopsContext";
import Loading from "../../../components/Loading";
import DateFormatter from "../../../components/DateFormatter";

function CourseDetailParticipants({ course }) {
    const shopsContext = useContext(ShopsContext);
    const [shopUsers, setShopUsers] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [error, setError] = useState(null);

    useEffect(() => {
        if(!course) {
            return;
        }
        const loadParticipants = async () => {
            setError(null);
            setShopUsers(null);
            setSearchQuery("");
            try {
                const response = await axios.post("/getCourseShopUsersWithAccess", {
                    shopId: shopsContext.currentShop.id,
                    courseId: course.id,
                });
                setShopUsers(response.data.shopUsers);
            } catch(requestError) {
                console.error(requestError);
                setError("Er ging iets fout. Probeer het later opnieuw.");
            }
        }
        loadParticipants();
    }, [course, shopsContext.currentShop.id]);

    if(error) {
        return (
            <Alert variant="danger">{ error }</Alert>
        );
    }
    if(!shopUsers) {
        return (
            <Loading/>
        );
    }
    if(shopUsers.length === 0) {
        return (
            <div className="d-flex flex-column align-items-center text-center">
                <h1><i className="fas fa-graduation-cap"/></h1>
                <h4>Geen deelnemers</h4>
                <p>Deze cursus heeft nog geen deelnemers.</p>
            </div>
        )
    }
    const baseUrl = "/shop/" + shopsContext.currentShop.codeName;
    const trimmedSearchQuery = searchQuery.trim().toLowerCase();
    const searchParts = trimmedSearchQuery.length > 0 ? trimmedSearchQuery.split(/\s+/) : [];
    const filteredShopUsers = shopUsers.filter((shopUser) => {
        if(searchParts.length === 0) {
            return true;
        }
        const searchableValues = [
            shopUser.id?.toString(),
            shopUser.name,
            shopUser.email
        ].filter(Boolean).map((value) => value.toLowerCase());
        return searchParts.every((part) => searchableValues.some((value) => value.includes(part)));
    });

    return (
        <React.Fragment>
            <div className="d-flex flex-column flex-md-row align-items-md-center mb-3">
                <div className="flex-grow-1">
                    <p className="text-muted mb-3 mb-md-0">
                        { trimmedSearchQuery.length > 0 ? (
                            <React.Fragment>
                                { filteredShopUsers.length } van { shopUsers.length } deelnemer{ shopUsers.length === 1 ? "" : "s" } gevonden.
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                Deze cursus heeft { shopUsers.length } deelnemer{ shopUsers.length === 1 ? "" : "s" }.
                            </React.Fragment>
                        ) }
                    </p>
                </div>
                <Form.Group className="mb-0 w-100 ml-md-3" style={{
                    maxWidth: "400px"
                }}>
                    <Form.Control
                        aria-label="Zoek deelnemers"
                        type="search"
                        value={ searchQuery }
                        onChange={ (event) => setSearchQuery(event.target.value) }
                        placeholder="Zoek op naam of e-mailadres"
                    />
                </Form.Group>
            </div>
            <Table size="sm" hover>
                <thead className="thead-light">
                <tr className="tr-sticky">
                    <th className="text-center">#</th>
                    <th className="text-left">Naam</th>
                    <th className="text-left">Email</th>
                    <th className="text-center">Toegang</th>
                    <th className="text-right">Toegang sinds</th>
                    <th className="text-right">Verloopdatum</th>
                </tr>
                </thead>
                <tbody>
                { filteredShopUsers.map((shopUser) => {
                    const url = baseUrl + "/shop-user/" + shopUser.id;
                    return (
                        <tr key={ shopUser.id } className="table-clickable-row">
                            <th className="text-center">
                                <Link to={ url }>
                                    { shopUser.id }
                                </Link>
                            </th>
                            <td className="text-left">
                                <Link to={ url }>
                                    { shopUser.name }
                                </Link>
                            </td>
                            <td className="text-left">
                                <Link to={ url }>
                                    { shopUser.email }
                                </Link>
                            </td>
                            <td className="text-center">
                                <Link to={ url }>
                                    { shopUser.courseAccess?.hasAccess ? (
                                        <i className="fa-solid fa-check fa-fw text-success"/>
                                    ) : (
                                        <i className="fa-solid fa-times fa-fw text-danger"/>
                                    )}
                                </Link>
                            </td>
                            <td className="text-right">
                                <Link to={ url }>
                                    <DateFormatter date={ shopUser.courseAccess?.firstAccessDate }/>
                                </Link>
                            </td>
                            <td className="text-right">
                                <Link to={ url }>
                                    { shopUser.courseAccess?.expirationDate ? (
                                        <DateFormatter date={ shopUser.courseAccess?.expirationDate }/>
                                    ) : (
                                        "Nooit"
                                    )}
                                </Link>
                            </td>
                        </tr>
                    )
                }) }
                { filteredShopUsers.length === 0 && (
                    <tr>
                        <td colSpan={ 6 } className="text-center text-muted py-4">
                            <h4><i className="fas fa-search"/></h4>
                            <p className="mb-0">
                                Geen deelnemers gevonden voor <b>{ searchQuery.trim() }</b>.
                            </p>
                        </td>
                    </tr>
                ) }
                </tbody>
            </Table>
        </React.Fragment>
    )
}
CourseDetailParticipants.propTypes = {
    course: PropTypes.object,
}

export default React.memo(CourseDetailParticipants);
